import { useSyncExternalStore } from "react"
import {
	getLocale as runtimeGetLocale,
	setLocale as runtimeSetLocale,
} from "../../../paraglide/runtime.js"

const subscribers = new Set<() => void>()

function subscribe(cb: () => void): () => void {
	subscribers.add(cb)
	return () => {
		subscribers.delete(cb)
	}
}

function notify(): void {
	for (const cb of subscribers) cb()
}

type SetLocaleOptions = { reload?: boolean }

export function setLocale(
	newLocale: Parameters<typeof runtimeSetLocale>[0],
	options?: SetLocaleOptions,
): ReturnType<typeof runtimeSetLocale> {
	const result = runtimeSetLocale(newLocale, options)
	if (options?.reload === false) {
		if (result instanceof Promise) {
			return result.then(notify)
		}
		notify()
	}
	return result
}

export function useLocale() {
	return useSyncExternalStore(subscribe, runtimeGetLocale, runtimeGetLocale)
}
